import React from 'react';
import PropTypes from 'prop-types';
import { Box, makeStyles } from '@material-ui/core';

function SubquestionBox({ color, children }) {
  const classes = makeStyles((theme) => ({
    box: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      paddingBottom: theme.spacing(2),
      marginTop: theme.spacing(4),
      borderLeft: `12px solid ${color}`,
      borderBottom: `12px solid ${color}`,
      '@media print': {
        borderLeft: 'none',
        borderBottom: 'none',
      },
    },

  }))();

  return (
    <Box className={classes.box}>
      {children}
    </Box>
  );
}

SubquestionBox.propTypes = {
  color: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node), // as you can render an array of elements
    PropTypes.element, // for a single component/element
  ]).isRequired,
};

export default SubquestionBox;
